import React from 'react';
import { Box } from '@chakra-ui/react';
import PulseLogoLoader from './PulseLogoLoader';

const LoadingOverlay = ({ isLoading, text }) => {
    if (!isLoading) return null;

    return (
        <Box
            position="fixed"
            top={0}
            left={0}
            right={0}
            bottom={0}
            zIndex={9999}
            bg="rgba(255, 255, 255, 0.1)" // More transparent for "Glass" feel
            backdropFilter="blur(8px)"    // Blur effect
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            {/* Reuse PulseLogoLoader but ensure it handles transparent bg well */}
            <PulseLogoLoader text={text} bg="transparent" position="relative" zIndex="auto" />
        </Box>
    );
};

export default LoadingOverlay;
